import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { Select, type SelectProps, type ComboboxProps } from '@mantine/core'
import { clsx } from 'clsx'
import { useEffect, useState, forwardRef, type Ref } from 'react'

import { Icon } from '../../src'
import styles from './styles.module.css'
import { useHoursList } from './useHoursList'

export type TimePickerInputProps = {
  value?: string | null
  minTime?: string
  maxTime?: string
  intervalMinutes?: number
  comboboxProps?: Omit<ComboboxProps, 'children'>
  showTimeIcon?: boolean
  onChange?: (time: string | null) => void
} & Omit<SelectProps, 'data' | 'value' | 'onChange'>

export const TimePickerInput = forwardRef(function TimePickerInput(
  {
    value,
    minTime,
    maxTime,
    intervalMinutes,
    showTimeIcon = true,
    onChange,
    ...props
  }: TimePickerInputProps,
  ref: Ref<HTMLInputElement>
) {
  const [hours, setHours] = useState(
    useHoursList({
      minTime,
      maxTime,
      intervalMinutes,
    })
  )

  useEffect(() => {
    setHours(useHoursList({ minTime, maxTime, intervalMinutes }))
  }, [minTime, maxTime])

  useEffect(() => {
    if (value && !hours.find((time) => time === value)) {
      setHours([value, ...hours])
    }
  }, [value])

  return (
    <Select
      placeholder='00:00'
      ref={ref}
      {...(props as SelectProps)}
      searchable
      clearable={props.clearable}
      value={value}
      onChange={onChange}
      data={hours}
      allowDeselect={false}
      leftSection={showTimeIcon && <Icon icon={faClock} />}
      className={clsx(styles.timePickerInput, props.className)}
    />
  )
})
